module.exports = __webpack_public_path__ + "img/10200.b032ecaa.jpg";